/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
import * as React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import OktaSignIn from '@okta/okta-signin-widget';
import '@okta/okta-signin-widget/dist/css/okta-sign-in.min.css';
import { oktaSignInConfig } from '../../shared/okta-config';
import CircularProgress from '@material-ui/core/CircularProgress';
import * as styles from './login.module.scss';

const OktaLoginCallback = () => {
  const { oktaAuth } = useOktaAuth();
  const widgetRef = React.useRef(null);

  React.useEffect(() => {
    if (!widgetRef.current) {
      return;
    }

    const widget = new OktaSignIn(oktaSignInConfig);

    widget.authClient.session.exists().then(function(sessionExists) {
      if (sessionExists) {
        widget.authClient.token.getWithoutPrompt().then(function(response) {
          oktaAuth.handleLoginRedirect(response.tokens);
        });
      }
    });

    return () => widget.remove();
  }, [oktaAuth]);

  return (
    <div className={styles.login}>
      <div ref={widgetRef} />
      <div>
        <CircularProgress />
      </div>
    </div>
  );
};
export default OktaLoginCallback;
